import { mutator } from 'satcheljs';
import getStore from '../store/store';
import enableDisableProfile from '../actions/enableDisableProfile';

/**
 * Enable/disable profile mutator.
 */
export default mutator(enableDisableProfile, actionMessage => {
    let store = getStore();
    const profile = store.profiles.get(actionMessage.serviceId);
    profile.ExcludeFromSelfService = !actionMessage.enable;
});
